<template>
  <div class="availability-checker">
    <div class="availability-checker-input">
      <p v-text="title" class="pb-1"></p>
      <div class="py-1"></div>
      <autocomplete-address-field v-model="addressObjectId" :inputplaceholder="inputplaceholder"></autocomplete-address-field>
      <button class="button-primary blue-transparent" :disabled="addressObjectId == null" ref="submit">
        <span v-text="buttontitle"></span>
        <i class="fad fa-arrow-right"></i>
      </button>
    </div>
    <div class="backdrop" :class="{ hidden: !modalShow }" @click="modalShow = false">
      <div class="modal-container success" @click="$event.stopPropagation()">
        <div class="modal">
          <div class="close-button" @click="modalShow = false" style="position: absolute; right: 2rem; top: 2rem; width: 2rem; height: 2rem; cursor: pointer;">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"/></svg>
          </div>
          <h4 class="h3 mb-3 text-success" v-text="modalContentStatus">
            <i class="fad fa-check ml-3 text-success" aria-hidden="true"></i>
          </h4>
          <div>
            <i class="fad fa-map-pin mr-2 text-success"></i>
            <span class="hidden sm:inline">Standort:</span>
            <strong v-text="modalContentStandort"></strong>
          </div>
          <div class="mt-3" v-html="modalContentDescription"></div>
          <div class="mt-3" v-html="modalHtml"></div>
          <div class="flex flex-wrap lg:flex-nowrap justify-between items-center pt-2 mt-3">
            <div class="flex w-full lg:w-auto">
              <span>Zuletzt aktualisiert:</span>&nbsp;<span v-text="modalContentUpdate"></span>
            </div>
            <div class="flex w-full lg:w-auto">
              <a data-toggle="modal" :href="modalregisterlink" class="button-primary green-transparent">
                <span>Jetzt anmelden</span>
                <i class="fad fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
    },
    inputplaceholder: {
      type: String,
    },
    buttontitle: {
      type: String,
    },
    modalregisterlink: {
      type: String
    }
  },
  data() {
    return {
      addressObjectId: null,
      modalShow: false,
      modalHtml: "",
      modalContentId: 0,
      modalContentUpdate: "",
      modalContentStandort: "",
      modalContentStatus: "",
      modalContentDescription: "",
    };
  },
  methods: {
  },
  mounted() {
    let buttonSubmit = this.$refs.submit;

    buttonSubmit.addEventListener("click", async (event) => {
      if (!this.addressObjectId) {
        this.modalShow = false;
        return;
      }

      const data = await fetch(`status/${this.addressObjectId}`).then(response => response.json());

      this.modalShow = true;
      this.modalHtml = data.html;
      this.modalContentId = data.id;
      this.modalContentUpdate = data.last_updated;
      this.modalContentStandort = data.standort;
      this.modalContentStatus = data.status;
      this.modalContentDescription = data.statusbeschreibung;
    });
  },
};
</script>
